import { Link } from 'react-router-dom';
import { MapPin, Phone, Mail, Clock, Facebook, Instagram } from 'lucide-react';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_hilanta-wellness/artifacts/yzd7rzdb_76b87d66-fa32-4fab-93bc-4ef8dc416573.jpg";
const INSTAGRAM_URL = 'https://www.instagram.com/espace_hilanta/';

const openInstagram = (e) => {
  e.preventDefault();
  const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
  if (isMobile) {
    window.location = 'instagram://user?username=espace_hilanta';
    setTimeout(() => { window.open(INSTAGRAM_URL, '_blank'); }, 1500);
  } else {
    window.open(INSTAGRAM_URL, '_blank');
  }
};

const Footer = () => {
  return (
    <footer className="bg-gradient-to-br from-warm-brown to-warm-brown/90 text-white" data-testid="footer">
      {/* Decorative top border */}
      <div className="h-1 bg-gradient-to-r from-terracotta via-gold to-sage"></div>
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="space-y-4 text-center md:text-left">
            <div className="flex flex-col sm:flex-row items-center gap-3 justify-center md:justify-start">
              <img 
                src={LOGO_URL} 
                alt="Hilanta" 
                className="h-16 w-16 sm:h-20 sm:w-20 rounded-full object-cover border-4 border-gold/50 shadow-lg"
              />
              <div>
                <h3 className="font-heading text-xl sm:text-2xl font-semibold">HILANTA</h3>
                <p className="text-sm text-white/80">Massages & Bien-être</p>
              </div>
            </div>
            <p className="font-body text-white/90 leading-relaxed italic text-sm sm:text-base">
              "Santé du corps, paix d'esprit et amour du cœur"
            </p>
            
            {/* Social Media */}
            <div className="flex gap-4 pt-4 justify-center md:justify-start">
              <a 
                href="https://www.facebook.com/people/Hilanta-Bien-%C3%AAtre/pfbid034xjX8MidrV5xgfZ27Xjorzux3HLxbKxrawbpPuBDqZ4BcBkrZ9uvVMh4QaFssXYwl/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-12 h-12 bg-white/10 hover:bg-terracotta rounded-full flex items-center justify-center transition-all duration-300 hover:scale-110"
                data-testid="social-facebook"
              >
                <Facebook size={24} className="text-white" />
              </a>
              <a 
                href={INSTAGRAM_URL}
                onClick={openInstagram}
                className="w-12 h-12 bg-white/10 hover:bg-gradient-to-br hover:from-purple-500 hover:to-pink-500 rounded-full flex items-center justify-center transition-all duration-300 hover:scale-110"
                data-testid="social-instagram"
              >
                <Instagram size={24} className="text-white" />
              </a>
            </div>
          </div>

          {/* Navigation */}
          <div>
            <h4 className="font-heading text-xl mb-4 text-gold">Navigation</h4>
            <ul className="space-y-3 font-body">
              <li>
                <Link to="/" className="text-white/80 hover:text-gold transition-colors flex items-center gap-2" data-testid="footer-link-accueil">
                  <span className="w-1.5 h-1.5 bg-terracotta rounded-full"></span>
                  Accueil
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-white/80 hover:text-gold transition-colors flex items-center gap-2" data-testid="footer-link-services">
                  <span className="w-1.5 h-1.5 bg-terracotta rounded-full"></span>
                  Nos Prestations
                </Link>
              </li>
              <li>
                <Link to="/reservation" className="text-white/80 hover:text-gold transition-colors flex items-center gap-2" data-testid="footer-link-reservation">
                  <span className="w-1.5 h-1.5 bg-terracotta rounded-full"></span>
                  Réservation
                </Link>
              </li>
              <li>
                <Link to="/abonnements" className="text-white/80 hover:text-gold transition-colors flex items-center gap-2" data-testid="footer-link-abonnements">
                  <span className="w-1.5 h-1.5 bg-terracotta rounded-full"></span>
                  Abonnements
                </Link>
              </li>
              <li>
                <Link to="/carte-cadeau" className="text-white/80 hover:text-gold transition-colors flex items-center gap-2" data-testid="footer-link-carte-cadeau">
                  <span className="w-1.5 h-1.5 bg-terracotta rounded-full"></span>
                  Offrir un Soin
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-white/80 hover:text-gold transition-colors flex items-center gap-2" data-testid="footer-link-contact">
                  <span className="w-1.5 h-1.5 bg-terracotta rounded-full"></span>
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Prestations */}
          <div>
            <h4 className="font-heading text-xl mb-4 text-gold">Nos Prestations</h4>
            <ul className="space-y-3 font-body text-white/80">
              <li className="flex items-center gap-2">
                <span className="w-1.5 h-1.5 bg-sage rounded-full"></span>
                Massages bien-être
              </li>
              <li className="flex items-center gap-2">
                <span className="w-1.5 h-1.5 bg-sage rounded-full"></span>
                Naturopathie
              </li>
              <li className="flex items-center gap-2">
                <span className="w-1.5 h-1.5 bg-sage rounded-full"></span>
                Activités créatives
              </li>
              <li className="flex items-center gap-2">
                <span className="w-1.5 h-1.5 bg-sage rounded-full"></span>
                Ateliers enfants
              </li>
              <li className="flex items-center gap-2">
                <span className="w-1.5 h-1.5 bg-sage rounded-full"></span>
                Conférences santé
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-heading text-xl mb-4 text-gold">Contact</h4>
            <ul className="space-y-4 font-body">
              <li className="flex items-start gap-3">
                <div className="w-10 h-10 bg-terracotta/30 rounded-full flex items-center justify-center flex-shrink-0">
                  <MapPin size={18} className="text-gold" />
                </div>
                <a 
                  href="https://www.google.com/maps/search/?api=1&query=58+Avenue+Maréchal+Foch+13004+Marseille"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-white/90 hover:text-gold transition-colors"
                  data-testid="footer-address"
                >
                  58 Avenue Maréchal Foch<br />
                  13004 Marseille
                </a>
              </li>
              <li className="flex items-center gap-3">
                <div className="w-10 h-10 bg-terracotta/30 rounded-full flex items-center justify-center flex-shrink-0">
                  <Phone size={18} className="text-gold" />
                </div>
                <a href="tel:0960421822" className="text-white/90 hover:text-gold text-lg font-semibold" data-testid="footer-phone">
                  09 60 42 18 22
                </a>
              </li>
              <li className="flex items-center gap-3">
                <div className="w-10 h-10 bg-terracotta/30 rounded-full flex items-center justify-center flex-shrink-0">
                  <Mail size={18} className="text-gold" />
                </div>
                <a href="mailto:la.hilanta@gmail.com" className="text-white/90 hover:text-gold" data-testid="footer-email">
                  la.hilanta@gmail.com
                </a>
              </li>
              <li className="flex items-center gap-3">
                <div className="w-10 h-10 bg-terracotta/30 rounded-full flex items-center justify-center flex-shrink-0">
                  <Clock size={18} className="text-gold" />
                </div>
                <div className="text-white/90" data-testid="footer-hours">
                  <span className="font-semibold">Horaires :</span><br />
                  Mar - Sam : 10h - 18h
                </div>
              </li>
            </ul>
          </div>
        </div>

        {/* QR Code Google Reviews */}
        <div className="mt-8 flex flex-col md:flex-row items-center justify-center gap-6 bg-white/10 rounded-2xl p-6">
          <div className="text-center">
            <h4 className="font-heading text-lg text-gold mb-2">Votre avis compte !</h4>
            <p className="text-white/80 text-sm mb-3">Scannez pour laisser un avis Google</p>
            <img 
              src="/qr-google-avis.png" 
              alt="QR Code Avis Google" 
              className="w-24 h-24 mx-auto rounded-lg bg-white p-1"
            />
          </div>
          <div className="text-center md:text-left">
            <a 
              href="https://www.google.com/maps/place//data=!4m3!3m2!1s0x12c9bf541fc7664d:0xea5c20b80d09e886!12e1?source=g.page.m.ia._&laa=nmx-review-solicitation-ia2"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 bg-gold hover:bg-gold/80 text-warm-brown font-semibold px-6 py-3 rounded-full transition-all"
            >
              ⭐ Laisser un avis
            </a>
          </div>
        </div>

        {/* Call to Action Banner */}
        <div className="mt-12 bg-gradient-to-r from-terracotta to-terracotta-600 rounded-2xl p-8 text-center">
          <h3 className="font-heading text-2xl mb-2">Laissez-vous guider vers vos racines</h3>
          <p className="font-body text-white/90 mb-4">Réservez votre séance de bien-être dès maintenant</p>
          <Link to="/reservation">
            <button className="bg-white text-terracotta font-body font-semibold px-8 py-3 rounded-full hover:bg-gold hover:text-white transition-all duration-300 shadow-lg hover:shadow-xl">
              Réserver maintenant
            </button>
          </Link>
        </div>

        {/* Copyright */}
        <div className="mt-12 pt-8 border-t border-white/20 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="font-body text-sm text-white/70">
            © {new Date().getFullYear()} HILANTA - Tous droits réservés
          </p>
          <div className="flex items-center gap-6">
            <span className="font-body text-sm text-white/70">Suivez-nous :</span>
            <a 
              href="https://www.facebook.com/people/Hilanta-Bien-%C3%AAtre/pfbid034xjX8MidrV5xgfZ27Xjorzux3HLxbKxrawbpPuBDqZ4BcBkrZ9uvVMh4QaFssXYwl/" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-white/70 hover:text-gold transition-colors"
            >
              <Facebook size={20} />
            </a>
            <a 
              href={INSTAGRAM_URL}
              onClick={openInstagram}
              className="text-white/70 hover:text-gold transition-colors"
            >
              <Instagram size={20} />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
